import { render } from "./Header_c.vue?vue&type=template&id=4a547fd6&scoped=true"
import script from "./Header_c.vue?vue&type=script&lang=js"
export * from "./Header_c.vue?vue&type=script&lang=js"

import "./Header_c.vue?vue&type=style&index=0&id=4a547fd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a547fd6"

export default script